import { useEffect, useMemo } from "react";
import { Col, Descriptions, List, Row, Spin } from "antd";
import '@xyflow/react/dist/style.css';
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { operationDetailsClear, operationDetailsRequest } from "src/store/actions/operations";
import { StoreState } from "src/store/configureStore";
import { FileExcelOutlined, LoadingOutlined } from "@ant-design/icons";
import { AsyncStates } from "src/constants";


export const Details = () => {
  const dispatch = useDispatch()
  const { opid } = useParams<{ opid: string }>()

  useEffect(() => {
    dispatch(operationDetailsRequest({ opid }))
  }, [dispatch, opid])
  const detailsStatus = useSelector((state: StoreState) => state.operations.operationDetailsStatus)
  const details = useSelector((state: StoreState) => state.operations.operationDetailsData)
  const detailsItems = useMemo(() => [
    {
      key: "name",
      label: "Name",
      children: details.name
    },
    // {
    //   key: "description",
    //   label: "Description",
    //   children: details.description
    // },
    // {
    //   key: "customer",
    //   label: "Customer",
    //   children: details.customer
    // },
    {
      key: "category",
      label: "Category",
      children: details.category
    },
    // {
    //   key: "date",
    //   label: "Date",
    //   children: details.date
    // },
    // {
    //   key: "location",
    //   label: "Location",
    //   children: details.location
    // },
    // {
    //   key: "created_by",
    //   label: "Created by",
    //   children: details.createdBy
    // },
    // {
    //   key: "members",
    //   label: "Members",
    //   children: details.members
    // },
  ], [details])

  useEffect(() => {
    return () => {
      dispatch(operationDetailsClear())
    }
  }, [dispatch])

  return (
    <Spin spinning={detailsStatus === AsyncStates.LOADING} indicator={<LoadingOutlined />}>
      <Row gutter={16}>
        <Col span={12}>
          <Row>
            <Descriptions
              size="small"
              style={{ width: "100%" }}
              bordered
              column={1}
              items={detailsItems} />
          </Row><br />
          {/* <Row>
            <Typography.Title level={5}>Notes</Typography.Title>
            <Input.TextArea rows={2} placeholder="Add note." />
            <Flex justify="flex-end" gap={8} style={{ width: "100%", paddingTop: 8 }}>
              <StyledButton size="small">Cancel</StyledButton>
              <StyledButton size="small" type="primary">Add</StyledButton>
            </Flex>
          </Row> */}
        </Col>
        <Col span={12}>
          <List
            header="Attachments"
            size="small"
            itemLayout="horizontal"
            dataSource={details?.datasets?.map((dataset: any) => ({ title: dataset.name }))}
            renderItem={(item: any) => (
              <List.Item>
                <List.Item.Meta
                  avatar={<FileExcelOutlined />}
                  title={item.title}
                  description="Dataset"
                />
              </List.Item>
            )}
          />
        </Col>
      </Row>
    </Spin>
  );
}